import React from "react";

export default function ShimmerTable({ rows = 18, cols = 5 }) {
  var shimmerArray = new Array(rows).fill(null);
  return (
    <div>
      <table className="shimmerTable">
        <tbody>
          {shimmerArray.map((i, index) => {
            return (
              <tr key={index}>
                <td>
                  <span className="line loading-shimmer"></span>
                </td>
                <td>
                  <span className="line loading-shimmer"></span>
                </td>
                <td>
                  <span className="line loading-shimmer"></span>
                </td>
                <td>
                  <span className="line loading-shimmer"></span>
                </td>
                <td>
                  <span className="line loading-shimmer"></span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
